"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@emotion/react");
var _Typography = _interopRequireDefault(require("../atoms/Typography"));
var _Row = _interopRequireDefault(require("./Row"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _Section = require("./Section");
var _Icon = _interopRequireDefault(require("../atoms/Icon"));
var _templateObject, _templateObject2;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function Article(_ref) {
  var _colors$FONT, _descriptionProps$dan;
  let {
    title,
    iconName,
    titleProps,
    titleAfterStyles,
    description,
    descriptionAfterStyles,
    descriptionProps,
    rightChild,
    children,
    className,
    styles
  } = _ref;
  const {
    colors
  } = (0, _react2.useTheme)();
  return /*#__PURE__*/_react.default.createElement(Container, {
    className: className,
    styles: styles
  }, /*#__PURE__*/_react.default.createElement("header", null, /*#__PURE__*/_react.default.createElement(StyledHeaderRow, {
    align: "space-between"
  }, /*#__PURE__*/_react.default.createElement(_Row.default, {
    gap: 10
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconName,
    color: colors === null || colors === void 0 || (_colors$FONT = colors.FONT) === null || _colors$FONT === void 0 ? void 0 : _colors$FONT.TITLE,
    size: 15,
    datasets: {
      'data-title-icon': true,
      'data-title-icon-display': Boolean(iconName)
    }
  }), /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    type: "title-4",
    lineHeight: 30,
    size: 16,
    children: title,
    "data-title": true,
    afterStyles: titleAfterStyles
  }, titleProps))), rightChild), Boolean((description === null || description === void 0 ? void 0 : description.length) || (descriptionProps === null || descriptionProps === void 0 || (_descriptionProps$dan = descriptionProps.dangerouslySetInnerHTML) === null || _descriptionProps$dan === void 0 ? void 0 : _descriptionProps$dan.__html)) && /*#__PURE__*/_react.default.createElement(_Typography.default, _extends({
    type: "description",
    size: 12,
    datasets: {
      type: 'description'
    },
    afterStyles: descriptionAfterStyles,
    children: description
  }, descriptionProps))), children);
}
const Container = _styled.default.article(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n\n  [data-title-icon-display='false'] {\n    display: none;\n  }\n\n  @media screen and (min-width: 768px) {\n    [type='description'] {\n      font-size: 16px;\n    }\n  }\n"])), _ref2 => {
  let {
    styles
  } = _ref2;
  return styles;
});
const StyledHeaderRow = (0, _styled.default)(_Row.default)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  @media screen and (min-width: 768px) {\n    h4:first-of-type {\n      font-size: 22px;\n      line-height: 34px;\n    }\n\n    [data-title-icon='true'] {\n      font-size: 22px;\n    }\n  }\n"])));
Article.RightChildAsButton = _Section.RightChildAsButton;
var _default = exports.default = Article;